/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react'
import { useHookstate } from '@hookstate/core'
import Layout from '~/components/Layout'
import { useLang } from '~/hooks/useLang'
import CrudIndex from '~/components/CrudIndex'

// no types required since results are not rendered here
export default function Index() {
  const { translate } = useLang()

  const name = useHookstate<string | null>(null)
  const code = useHookstate<string | null>(null)
  const materialGroupId = useHookstate<number | null>(null)
  const measurementUnitId = useHookstate<number | null>(null)
  const forceRefresh = useHookstate(false)

  useEffect(() => {
    document.title = translate('Resources - Dispatch System')
  }, [])



  return (
    <Layout marginLayout={true}>
      <CrudIndex
        model='material'
        title='Materials'
        createTitleComplement='Material'
        aliasLabel={[
          { column: 'material_group:name', label: 'Grupo de material' },
          { column: 'measurement_unit:name', label: 'Unidade de medida' },
        ]}
        forceOrderColumns={['name', 'code', 'material_group:name', 'measurement_unit:name']}
        filters={[
          { name: 'name', type: 'name', variable: name },
          { name: 'code', type: 'code', variable: code },
          { name: 'material_group_id', type: 'material_group_id', variable: materialGroupId },
          { name: 'measurement_unit_id', type: 'measurement_unit_id', variable: measurementUnitId },
        ]}
        clearFilters={() => {
          name.set('')
          code.set('')
          materialGroupId.set(null)
          measurementUnitId.set(null)
          forceRefresh.set(!forceRefresh.get())
        }}
        searchButton={() => forceRefresh.set(!forceRefresh.get())}
        forceRefresh={forceRefresh.get()}
        disableColumnsFilters
        canView={true}
        showInViewMore={['name', 'code', 'material_group:name', 'measurement_unit:name', 'created_at']}
        viewTitle='Material'
      />
    </Layout>
  )
}
